/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Amandeep Singh",
  title: "Hi all, I'm Amandeep",
  subTitle: emoji(
    "Welcome to my digital playground! I’m a software engineer 🚀 with a zest for coding solutions that speak, interact, and sometimes, when they’re feeling fancy, dance across the screen."
  ),
  resumeLink:
    'https://docs.google.com/document/d/e/2PACX-1vQmweP-dW9-DfcKqUAyEcVRWc0ThG07OfVdTfU8rA3SLFN9XF2q5Geqtup3ZLekYRFlOjZ1MRIP_ZjL/pub', // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/AmandeepSingh789",
  linkedin: "https://www.linkedin.com/in/amandeep-singh-a56aa5236/",
  gmail: "singh.amandeep5665@gmail.com",
  twitter:"https://twitter.com/AceofDevs",

  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "I Do Legendary Stuff.",
  skills: [
    emoji(
      "⚡ Crafting full-stack web and mobile applications with a focus on functionality, user experience, and responsive design"
    ),
    emoji("⚡ Leveraging the power of AWS to build scalable, efficient cloud infrastructure and optimize application performance"),
    emoji(
      "⚡ Developing and maintaining robust DevOps toolchains, integrating code versioning, automated testing, and deployment to streamline the software delivery process"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "sql",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "mongodb",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "solution architecture",
      fontAwesomeClassname: "fas fa-cloud"
    },
    
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "react native",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of California, Santa Cruz",
      logo: require("./assets/images/ucscLogo.png"),
      subHeader: "Bachelors in Computer Science",
      duration: "September 2019 - June 2023",
      desc: "Graduated with honors",
      descBullets: [
        "Completed a rigorous curriculum enhancing both theoretical knowledge and practical skills and laying a solid groundwork for understanding complex software systems.",
        "Collaborated with peers on numerous group projects, honing teamwork and communication skills essential for a career in software development."
      ]
    },

  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Data Analyst Consultant",
      company: "Kenvue",
      companylogo: require("./assets/images/kenvueLogo.png"),
      date: "Aug 2024 – Present",
      desc: "Contributing to the HR Analytics team by leveraging advanced data analysis and technology solutions to support strategic HR initiatives.",
      descBullets: [
        // "Presenting data-driven recommendations to stakeholders to support informed decision-making.",
        // "Collaborating with HR leaders to provide actionable insights on recruitment, performance, and employee engagement metrics."
      ]
    },
    {
      role: "Software Engineering Intern",
      company: "Cloud Brigade",
      companylogo: require("./assets/images/cbLogo.jpg"),
      date: "June 2022 - Sept 2022",
      desc: "Developed a proof of concept for a musical composition generator, to be proposed to Santa Cruz as a public art exhibit for 50K+ visitors."
    },
    {
      role: "Web Development Intern",
      company: "Codelattice Labs",
      companylogo: require("./assets/images/clLogo.jpg"),
      date: "June 2022 - Aug 2022",
      desc: "Developed 2 websites, ranging from product promotion to educational platforms."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "Some really cool stuff I worked on",
  projects: [
    {
      image: require("./assets/images/IVLogo.png"),
      projectName: "Inner Voice (In Progress)",
      projectDesc: "A cross platform mental wellness mobile app that helps users track their emotions and thoughts through daily questionnaires and journaling.",
      footerLink: [
        {
          name: "Demo",
          url: "https://twitter.com/AceofDevs/status/1797248941622518230?ref_src=twsrc%5Etfw%7Ctwcamp%5Eembeddedtimeline%7Ctwterm%5Escreen-name%3AAceofDevs%7Ctwcon%5Es1"
        },
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/tasselLogo.png"),
      projectName: "Tassel",
      projectDesc: "A web-app to connect UCSC Alumni with school events being hosted in their category of interests.",
      footerLink: [
        {
          name: "Demo",
          url: "https://drive.google.com/file/d/1MEAmI2AhT5pKdOU1DXjXckJWYHNIEEWJ/view?usp=sharing"
        },
        {
          name: "Docs",
          url: "https://docs.google.com/presentation/d/1_gt8LBooMg_fTtXkfN7hl2MhXJu9BruroaDRq460xH4/edit?usp=sharing"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/spotify_match_logo.png"),
      projectName: "Spotify Match",
      projectDesc: "A cross-platform mobile dating application that matches people based on their music preferences.",
      footerLink: [
        {
          name: "Demo",
          url: "https://youtu.be/I-BBJHrYe3E"
        },
        {
          name: "Code",
          url: "https://github.com/AmandeepSingh789/Spotify-Match"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "The good stuff",

  achievementsCards: [
    {
      title: "AWS Certified Cloud Practitioner",
      subtitle:
        "I know how to use AWS.",
      image: require("./assets/images/clf.png"),
      imageAlt: "CLF-C01",
      footerLink: [
        {
          name: "Credential",
          url: "https://www.credly.com/badges/9f5f9427-cfc4-49ce-815b-d931d4970e91/public_url"
        },
      ]
    },
    {
      title: "AWS Solutions Architect Associate",
      subtitle:
        "I know how to use AWS to create Solution Architectures.",
      image: require("./assets/images/saa.png"),
      imageAlt: "SAA-C03",
      footerLink: [
        {
          name: "Credential",
          url: "https://www.credly.com/badges/84076654-32d4-438f-93e3-2cb9038219ee/public_url"
        }
      ]
    },

  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Want to talk to me about the latest stuff happening in the tech world, a project, or just get a movie recommendation. Feel free to reach out and say hi",
  number: "+91 9622591707 / +1 8312665531",
  email_address: "singh.amandeep5665@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "AceofDevs", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
